<p id="logout">{{ 'Logout.headerTitle' | translate }}</p>
